import api from 'common/api';
import { areAllDocumentsMerged } from 'features/case/TableWrapper/utils/aiToolsMergeHelpers';

type FolderFilesApiResponse = {
  error?: unknown;
  results?: any[];
};

const getFilesFromResponse = (response: any): any[] => {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.results)) {
    return response.results;
  }

  return [];
};

export const fetchFolderFiles = async (caseId: string, folderId: string): Promise<any[]> => {
  if (!caseId || !folderId) {
    return [];
  }

  const response: unknown = await api.get(`/cases/${caseId}/folders/${folderId}/files`);
  const responseObject =
    response && typeof response === 'object' && !Array.isArray(response)
      ? (response as FolderFilesApiResponse)
      : undefined;

  if (responseObject?.error) {
    throw responseObject.error;
  }

  return getFilesFromResponse(response);
};

export const hasAllMergedFiles = (documents: any[] = []): boolean => areAllDocumentsMerged(documents);

export const shouldBlockAiForFolder = async (
  caseId: string,
  folderId: string,
): Promise<boolean> => {
  const documents = await fetchFolderFiles(caseId, folderId);
  return hasAllMergedFiles(documents);
};
